const NAMESPACE = 'REVIEW_FEED';

const SET_REVIEW_FEED_CONTENT = `${NAMESPACE}/SET_REVIEW_FEED_CONTENT`;

export {
    SET_REVIEW_FEED_CONTENT,
};

export default NAMESPACE;
